if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      // if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      document.querySelector(".loader_quick_view").classList.add('active');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          // material metafiled code
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="shopify-section-template--"]');
          console.log(">>>>>>>>A>AAAAA>AA>AA",this.productElement);
          setTimeout(function(){
          const h1Elements = document.querySelectorAll('.product-title');
          h1Elements.forEach(h1Element => {
          let text = h1Element.textContent;
          text = text.replace(/^[^:]+:\s*/, '');
          h1Element.textContent = text;
          });
            const closeButtons = document.querySelectorAll('.product_popup-modal_closeSize');
            closeButtons.forEach(button => {
            button.addEventListener('click', () => {
            const modals = document.querySelectorAll('modal-dialog.product_popup-modal_Size');
              modals.forEach(modal => {
              modal.removeAttribute('open');
              });
            });
            });
          document.querySelector(".available_stock").style.display = "none";
          document.querySelector(".available_stock").innerHTML = ``;
           const closeButtons_quick = document.querySelectorAll('.quick-add-modal__toggle');
            closeButtons_quick.forEach(button => {
            button.addEventListener('click', () => {
             const modals = document.querySelectorAll('.quick-add-modal');
              modals.forEach(modal => {
                  modal.removeAttribute('open');
              });
            });
            });
          },100)
          setTimeout(sortSelectOptions, 4000);
          setTimeout(()=>{
             const selectedSize = localStorage.getItem("selectedFilter");
                document.querySelector("quick-add-modal #dropdown-container").style.display = "none";
                document.querySelector(".dropdown").style.display = "flex";
            if (selectedSize) {
                const selectElements = document.querySelectorAll('.sizeSelect');
                selectElements.forEach(selectElement => {
                    const options = selectElement.options;
                    let matched = false;  // To check if the size was found
            
                    for (let i = 0; i < options.length; i++) {
                        if (options[i].value === selectedSize) {
                            selectElement.selectedIndex = i;  // Set the selected option based on matching size
                            const event = new Event('change');
                            selectElement.dispatchEvent(event);
                            matched = true;
                            break;
                        }
                    }
            
                    if (!matched) {
                        selectElement.selectedIndex = 0;  // Set to the first option if no match is found
                        const event = new Event('change');
                        selectElement.dispatchEvent(event);
                    }
                });
            }

          },2000)
          setTimeout(()=>{
            const swatches = document.querySelectorAll('.color-swatches .swatch');
            const labelValue = document.querySelector('.form__label__value');
            
            swatches.forEach(swatch => {
            swatch.addEventListener('mouseover', function() {
                const colorLabel = this.querySelector('label').textContent;
                labelValue.textContent = colorLabel;
            });
            });
            swatches.forEach(swatch => {
            swatch.addEventListener('mouseout', function() {
                // Uncomment the line below if you want to revert to the default color
                // labelValue.textContent = 'White'; // or any default color
            });
            });
          },3000)
          setTimeout(function(){
          document.getElementById('AddToCart').addEventListener('click', function(event) {
            const select = document.querySelector('select[name="options[Size]"]');
          var selectedValue = select.value;
          var errorMessage = document.getElementById('error_select_form');
          if (selectedValue === 'Choose Your Size') {
          event.preventDefault(); // Prevent form submission
          // alert("Choose Your Size")
          errorMessage.style.display="block";
          } else {
          }
          });
          },100);
// setTimeout(function(){
//   function updateHiddenInputAndButtonInOpenModal(variantId) {
//   var openModal = document.querySelector('quick-add-modal[open]');
//   if (openModal) {
//     var form = openModal.querySelector('form.form');
    
//     if (form) {
//       var hiddenInput = form.querySelector('input[name="id"]');
      
//       if (hiddenInput) {
//         hiddenInput.value = variantId;
//         console.log('Updated hidden input value in the open modal with value:', variantId);
//       } else {
//         console.error('Hidden input with name="id" not found within the form in the open modal');
//       }
//       var button = form.querySelector('button#AddToCart');
      
//       if (button) {
//         var buttonTextElement = button.querySelector('span.single-add-to-cart-button--text');
        
//         if (buttonTextElement) {
//           buttonTextElement.setAttribute('data-content', 'Add to Bag'); // Update the data-content attribute
//           console.log('Updated button text in the open modal to: Add to Cart');
//         } else {
//           console.error('Button text element not found within the button');
//         }
//       } else {
//         console.error('Button with ID "AddToCart" not found within the form in the open modal');
//       }
//     } else {
//       console.error('Form with class "form" not found within the open modal');
//     }
//   } else {
//     console.error('No open modal found');
//   }
// }
// var sizeSelect = document.getElementById('Option-template--18735772401920__main-0');
// sizeSelect.addEventListener('change', function() {
//   var selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
//   var variantId = selectedOption.getAttribute('variant_id');
//   updateHiddenInputAndButtonInOpenModal(variantId);
//   console.log('Selected variant ID:', variantId);
// });
//   },100);
          document.querySelector(".loader_quick_view").classList.remove('active');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();

          super.show(opener);
        })
 
        .finally(() => {

            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    setInnerHTML(element, html) {
 
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach((oldScriptTag,idx) => {
          // console.log('=============');
         // console.log('oldScriptTag', oldScriptTag,idx);
          // console.log('=================');
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          // $('quick-add-modal.quick-add-modal .product__media-list').slick('refresh');
        $('body').removeClass('modal-opening');
      


      });

       var collapsibleRows = document.querySelectorAll('collapsible-row.product__accordion.accordion');
          collapsibleRows.forEach(function(collapsibleRow) {
          var pTag = collapsibleRow.querySelector('.collapsible__content p');
          if (pTag && pTag.textContent.trim() === '') {
              collapsibleRow.style.display = 'none';
              }else{
              collapsibleRow.style.display = 'block';
             }
            });
 
    }
    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}

function sortSelectOptions() {
    const selectElement = document.querySelector('.sizeSelect'); 
    const optionList = Array.from(selectElement.options);

    // Sort options excluding the default option
    const sortedOptions = optionList.slice(1).sort((a, b) => {
      // Custom sorting logic based on numeric and alphabetic parts
      const valueA = a.value.trim();
      const valueB = b.value.trim();
      
      // Example: Sorting by numeric part first, then by alphabetic part
      const numPartA = parseInt(valueA); // Extract numeric part
      const numPartB = parseInt(valueB); // Extract numeric part

      // If numeric parts are different, sort by numeric part
      if (numPartA !== numPartB) {
        return numPartA - numPartB;
      }
      
      // Otherwise, sort by alphabetic part
      const alphaPartA = valueA.replace(/^\d+/, ''); // Extract alphabetic part
      const alphaPartB = valueB.replace(/^\d+/, ''); // Extract alphabetic part
      return alphaPartA.localeCompare(alphaPartB);
    });

    // Rebuild select options with sorted list
    sortedOptions.unshift(optionList[0]); // Add back the default option
    selectElement.innerHTML = ''; // Clear existing options
    
    // Add sorted options back to select element
    sortedOptions.forEach(option => {
      selectElement.appendChild(option);
    });
  }
